import React from "react";
import {
  Row,
  Col,
  Select,
  Input,
} from '@lockerpm/design';

import {
} from "@ant-design/icons";

import { useTranslation } from "react-i18next";
import global from "../../../../../config/global";

const Filter = (props) => {
  const { t } = useTranslation()
  const {
    className = '',
    params = {},
    accessLogClients = [],
    setParams = () => { }
  } = props;


  return (
    <Row
      className={`filter ${className}`}
      justify={'space-between'}
      gutter={[0, 8]}
    >
      <Col lg={24} md={24} className="w-full">
        <Row
          justify={'left'}
          gutter={[12, 12]}
        >
          <Col xl={4} lg={6} md={8} xs={24}>
            <p className="font-semibold mb-1">{t('access_key.id')}</p>
            <Input
              placeholder={t('placeholder.enter')}
              value={params.access_key_id}
              onChange={(e) => setParams({ ...params, access_key_id: e.target.value })}
            />
          </Col>
          <Col xl={4} lg={6} md={8} xs={12}>
            <p className="font-semibold mb-1">{t('common.access_type')}</p>
            <Select
              placeholder={t('placeholder.select')}
              className="w-full"
              value={params.type}
              allowClear
              onChange={(v) => setParams({ ...params, type: v })}
            >
              {global.constants.ACCESS_TYPES.map((type) => (
                <Select.Option
                  value={type.value}
                  key={type.value}
                >
                  {t(type.label)}
                </Select.Option>
              ))}
            </Select>
          </Col>
          <Col xl={4} lg={6} md={8} xs={12}>
            <p className="font-semibold mb-1">{t('common.client')}</p>
            <Select
              placeholder={t('placeholder.select')}
              className="w-full"
              value={params.client}
              allowClear
              onChange={(v) => setParams({ ...params, client: v })}
            >
              {accessLogClients.map((client) => (
                <Select.Option
                  value={client.name}
                  key={client.name}
                >
                  {client.name}
                </Select.Option>
              ))}
            </Select>
          </Col>
        </Row>
      </Col>
    </Row>
  );
}

export default Filter;
